import { render, staticRenderFns } from "./ProfeeCharts.vue?vue&type=template&id=168dbbde&"
import script from "./ProfeeCharts.vue?vue&type=script&lang=js&"
export * from "./ProfeeCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports